import UltMeta, { Meta } from "@/meta/UltMeta/index";

class deviceType extends UltMeta {
    CAMERA = new Meta(1, "摄像头");
    GPS = new Meta(2, "GPS");
}

export const DEVICE_TYPE = new deviceType();
/**
 * 运输工具类型
 */
class transportType extends UltMeta {
    SHIP = new Meta(1, "船舶");
    CAR = new Meta(2, "汽车");
}

export const TRANSPORT_TYPE = new transportType();
/**
 * 是否在线
 */
class online extends UltMeta {
    OFFLINE = new Meta(0, "离线");
    ONLINE = new Meta(1, "在线");
}

export const ONLINE = new online();
